import { render, staticRenderFns } from "./AlIcon.vue?vue&type=template&id=4f44badb&"
import script from "./AlIcon.vue?vue&type=script&lang=js&"
export * from "./AlIcon.vue?vue&type=script&lang=js&"
import style0 from "./AlIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports